import { createContext } from 'react';

type WorkflowCompletionContextInterface = {
  scrollWorkflowDialog: () => void;
  setHasQuebecAddress: (value: boolean) => void;
};

export const WorkflowCompletionContext =
  createContext<WorkflowCompletionContextInterface>({
    scrollWorkflowDialog: () => {},
    setHasQuebecAddress: () => {},
  });
